/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const MainContainerStyle = (
  backgroundImage: string,
  width = '70px',
  height = '80px'
) => {
  let _style: any = {
    backgroundColor: '#ffffff',
    cursor: 'pointer',
    textAlign: 'center',
    borderRadius: '20px',
    backgroundImage: 'url(' + backgroundImage + ')',
    width: width,
    height: height,
  };
  return _style;
};

export const ImageBackgroundStyle: any = {
  borderRadius: '20px',
  width: '100%',
  height: '100%',
  overflow: 'none',
  backdropFilter: 'blur(70px)',
  objectFit: 'contain',
  position: 'relative',
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px',
  margin: 0,
  minWidth: 0,
};

export const getImageStyle = () => {
  return {
    objectFit: 'cover',
    width: '100%',
    padding: 10,
    maxWidth: '100%',
    maxHeight: '100%',
    margin: '0 auto',
    textAlign: 'center',
    alignSelf: 'center',
    borderRadius: '20px',
  };
};
